﻿import { Authorization, trimToNull } from "@serenity-is/corelib";
import { PermissionExpressionLexer } from "@/Common/Permissions/PermissionExpressionLexer";
import { PermissionExpressionInterpreter } from "@/Common/Permissions/PermissionExpressionInterpreter";

const operatorChars = PermissionExpressionLexer.Operators.map(o => o.Value);

const oldHasPermission = Authorization.hasPermission;
Authorization.hasPermission = function (permission) {
    if (trimToNull(permission) == null || !operatorChars.some(c => permission.includes(c)))
        return oldHasPermission(permission);

    try {
        const tokens = new PermissionExpressionLexer(permission).Lex();
        return new PermissionExpressionInterpreter(tokens, oldHasPermission).Evaluate();
    } catch (e) {
        console.error("An error occurred while interpreting permission expression", e);
        return oldHasPermission(permission);
    }
}